var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainWrapper", attrs: { id: "top" } },
    [
      _c("head-nav", { attrs: { gray: _vm.gray, pos: "fixed" } }),
      _vm._v(" "),
      _c("div", { staticClass: "innerWrapper" }, [
        _c("div", { staticClass: "topWrp clear" }, [
          _c("div", { staticClass: "txt" }, [
            _c("h1", [
              _vm._v(
                "\n          Your " +
                  _vm._s(
                    _vm.tenant != "" ? _vm.tenant.toUpperCase() : "UNIFI"
                  ) +
                  " invoices\n        "
              )
            ]),
            _vm._v(" "),
            _c("h2", [
              _vm._v(
                "\n          When the status of one of your clients properties changes, we will\n          notify you here that it is time to send us an invoice for your\n          commission.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "more" }, [
            _c("h3", [_vm._v("Direct all invoices to:")]),
            _vm._v(" "),
            _c("h4", [
              _vm._v(
                _vm._s(_vm.tenant != "" ? _vm.tenant.toUpperCase() : "UNIFI")
              )
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: { target: "_blank", href: "mailto:" + _vm.contactEmail }
              },
              [_vm._v(_vm._s(_vm.contactEmail))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "botWrp" }, [
          _c("div", { staticClass: "tit clear" }, [
            _c(
              "h6",
              {
                class: [
                  _vm.tenantClassCur(_vm.pos, 0),
                  _vm.tenantClass(_vm.pos, 0)
                ],
                on: {
                  click: function($event) {
                    return _vm.change(0)
                  }
                }
              },
              [_vm._v("\n          Due invoices\n        ")]
            ),
            _vm._v(" "),
            _c(
              "h6",
              {
                class: [
                  _vm.tenantClassCur(_vm.pos, 1),
                  _vm.tenantClass(_vm.pos, 1)
                ],
                on: {
                  click: function($event) {
                    return _vm.change(1)
                  }
                }
              },
              [_vm._v("\n          Past invoices\n        ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtit" }, [
            _vm.pos == 0
              ? _c("p", [
                  _vm._v(
                    "\n          Please send\n          " +
                      _vm._s(
                        _vm.tenant != "" ? _vm.tenant.toUpperCase() : "UNIFI"
                      ) +
                      " invoices for the\n          following properties.\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pos == 1
              ? _c("p", [
                  _vm._v(
                    "\n          Below is a list of past invoices you have sent to UNIFI.\n        "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.pos == 0
            ? _c(
                "div",
                { staticClass: "boxs" },
                [
                  _vm._l(_vm.dueLst, function(item, index) {
                    return _c("div", { key: index, staticClass: "box clear" }, [
                      _c("div", { staticClass: "lft" }, [
                        _c("div", { staticClass: "date" }, [
                          _vm._v("Send now - " + _vm._s(item.time) + ":")
                        ]),
                        _vm._v(" "),
                        item.invoiceName !== ""
                          ? _c("div", { staticClass: "tip" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.invoiceName) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "number" }, [
                          _vm._v("#" + _vm._s(item.invoiceId))
                        ]),
                        _vm._v(" "),
                        item.invoiceType !== "bound"
                          ? _c("div", { staticClass: "more" }, [
                              _c("span", [_vm._v("property:")]),
                              _vm._v(_vm._s(item.property) + "\n            ")
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rgt" }, [
                        _c("div", { staticClass: "txt" }, [
                          _vm._v("$" + _vm._s(item.total))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "clear" }, [
                          _c(
                            "button",
                            {
                              class: { disabled: item.doneFlag == "yes" },
                              attrs: { disabled: item.doneFlag == "yes" },
                              on: {
                                click: function($event) {
                                  return _vm.mark(item.id, item.doneFlag, "due")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Invoice Sent\n              "
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _vm.due.totalRecord > 0 &&
                  _vm.due.totalRecord !== _vm.dueLst.length &&
                  !_vm.loadingDue
                    ? _c(
                        "div",
                        { staticClass: "loadMore", on: { click: _vm.loadDue } },
                        [_vm._v("\n          Load More\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingDue
                    ? _c("div", { staticClass: "loading" }, [
                        _vm._v("\n          loading"),
                        _c("i", { staticClass: "el-icon-loading" })
                      ])
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.pos == 1
            ? _c(
                "div",
                { staticClass: "boxs" },
                [
                  _vm._l(_vm.passLst, function(item, index) {
                    return _c("div", { key: index, staticClass: "box clear" }, [
                      _c("div", { staticClass: "lft" }, [
                        _c("div", { staticClass: "date" }, [
                          _vm._v("Send now - " + _vm._s(item.time) + ":")
                        ]),
                        _vm._v(" "),
                        item.invoiceName !== ""
                          ? _c("div", { staticClass: "tip" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.invoiceName) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "number" }, [
                          _vm._v("#" + _vm._s(item.invoiceId))
                        ]),
                        _vm._v(" "),
                        item.invoiceType !== "bound"
                          ? _c("div", { staticClass: "more" }, [
                              _c("span", [_vm._v("property:")]),
                              _vm._v(_vm._s(item.property) + "\n            ")
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rgt" }, [
                        _c("div", { staticClass: "txt" }, [
                          _vm._v("$" + _vm._s(item.total))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "clear" }, [
                          _c(
                            "button",
                            {
                              class: { disabled: item.doneFlag == "yes" },
                              attrs: { disabled: item.doneFlag == "yes" },
                              on: {
                                click: function($event) {
                                  return _vm.mark(
                                    item.id,
                                    item.doneFlag,
                                    "pass"
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Invoice sent\n              "
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _vm.pass.totalRecord > 0 &&
                  _vm.pass.totalRecord !== _vm.passLst.length &&
                  !_vm.loadingPass
                    ? _c(
                        "div",
                        {
                          staticClass: "loadMore",
                          on: { click: _vm.loadPass }
                        },
                        [_vm._v("\n          Load More\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingPass
                    ? _c("div", { staticClass: "loading" }, [
                        _vm._v("\n          loading"),
                        _c("i", { staticClass: "el-icon-loading" })
                      ])
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-062071eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-062071eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/invoice.vue
// module id = null
// module chunks = 